import { Box, Heading } from "@chakra-ui/react"
import React from "react"
import { DioboxEvent } from "sharedTypes"
import PreviewCard from "./PreviewCard"

type Props = {
  event: DioboxEvent
}

const EventTitle = ({
  event: {
    portalShowEventTitle,
    publicEventTitle,
  },
}: Props) => (
  <PreviewCard>
    <Box minH={8} py={2} textAlign="center" w="full" px={8}>
      {portalShowEventTitle && (
        <Heading
          as="h2"
          data-testid="preview-public-event-title"
          fontSize="3xl"
          fontWeight="semibold"
        >
          {publicEventTitle}
        </Heading>
      )}
    </Box>
  </PreviewCard>
)

export default EventTitle
